import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import LoginPage from '@/pages/LoginPage'
import PageNotFoundPage from '@/pages/PageNotFoundPage'
import ReleaseNotesPage from '@/pages/ReleaseNotesPage'
import NewErrand from '@/pages/NewErrand'
import AdminRootPage from '@/pages/Admin/RootPage'
import MemberPage from '@/pages/Admin/MemberPage'
import ErrandsPage from '@/pages/ErrandsPage'
import ErrandDetails from '@/pages/ErrandsDetails'
import Analytics from '@/pages/Analytics'
import Calendar from '@/pages/Calendar'
import SparkProInfoPage from '@/pages/SparkProInfoPage'
import FAQPage from '@/pages/FAQPage'

import OverviewPage from '@/pages/Errand/OverviewPage'
import EventHistoryPage from '@/pages/Errand/Events/EventHistoryPage'
import EventFilesPage from '@/pages/Errand/Events/EventFilesPage'
import ContactInformationPage from '@/pages/Errand/Contact/ContactInformationPage'
import ContactPersonPage from '@/pages/Errand/Contact/ContactPersonPage'
import MessageLog from '@/pages/Errand/MessageLog'

import _ from 'lodash'
import constants from '@/core/constants'
import authorizationService from '@/core/auth/authorization-service'
import featureService from '@/core/services/feature-service'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    component: LoginPage,
    meta: { hideFooter: true, hideLayout: true }
  },
  {
    path: '/errands',
    redirect: '/'
  },
  {
    path: '/changelog',
    component: ReleaseNotesPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/404',
    component: PageNotFoundPage,
    meta: { hideLayout: true }
  },

  {
    path: '/',
    component: ErrandsPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/calendar',
    component: Calendar,
    meta: { requiresAuth: true, isProFeature: true }
  },
  {
    path: '/analytics',
    component: Analytics,
    meta: { requiresAuth: true, isProFeature: true }
  },
  {
    path: '/new/:external_id_1',
    component: NewErrand,
    meta: { requiresAuth: true }
  },
  {
    path: '/spark-pro',
    component: SparkProInfoPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/FAQ',
    component: FAQPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/:errand_id',
    component: ErrandDetails,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: OverviewPage
      },
      {
        path: 'history',
        component: EventHistoryPage
      },
      {
        path: 'documents',
        component: EventFilesPage
      },
      {
        path: 'information',
        component: ContactInformationPage
      },
      {
        path: 'persons',
        component: ContactPersonPage
      },
      {
        path: 'message-log',
        component: MessageLog
      }
    ]
  },
  {
    path: '/admin',
    component: AdminRootPage,
    meta: { requiresAuth: true, roles: [constants.roles.globalAdmin, constants.roles.contentManager] },
    children: [
      { path: 'members', component: MemberPage }
    ]
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = _.some(to.matched, record => record.meta.requiresAuth)
  const isProFeature = _.some(to.matched, record => record.meta.isProFeature)
  const requiresRole = _.chain(to.matched).flatMap('meta.roles').compact().value()

  if (requiresAuth || to.fullPath === '/') {
    const hasRequiredRole = requiresRole.length === 0 || _.some(requiresRole, role => authorizationService.hasRole(role))
    if (store.getters.isAuthenticated && hasRequiredRole) {
      if(to.query.redirect) {
        next(to.query.redirect)
      } else if(isProFeature && !featureService.isSparkProUser()) {
        next({ path: '/spark-pro' })
      } else{
        next()
      }
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  } else {
    next()
  }
})

export default router
